// extracted by mini-css-extract-plugin
module.exports = {"flexStyle":"tab_flexStyle__2GESq","childBorderStyle":"tab_childBorderStyle__JkYfV","childTopBorderStyle":"tab_childTopBorderStyle__1c0JY"};